import { Component, OnDestroy, inject, output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';

import { AuthService } from 'app/services/auth.service';
@Component({
  selector: 'app-social-sign-up-modal',
  templateUrl: './modal-social-sign-up.component.html',
  styleUrls: ['./modal-social-sign-up.component.scss'],
  standalone: false,
})
export class ModalSocialSignUpComponent implements OnDestroy {
  private router = inject(Router);
  private authService = inject(AuthService);
  private store = inject(Store);

  public readonly shouldClose = output<boolean>();
  private destroyed$ = new ReplaySubject<boolean>(1);

  public async signIn(): Promise<void> {
    await this.authService.startSignInProcess({ reload: true });
  }

  public async confirmAccount(url: string): Promise<void> {
    const returnUrl = url || this.router.url;
    await this.router.navigate(['welcome/confirmAccount'], { queryParams: { return: returnUrl } });
    this.shouldClose.emit(true);
  }

  public async forgotPassword(url: string): Promise<void> {
    const returnUrl = url || this.router.url;
    await this.router.navigate(['welcome/forgotPassword'], { queryParams: { return: returnUrl } });
    this.shouldClose.emit(true);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
